export default __webpack_public_path__ + "static/media/deleteGrey.2b31358b.svg";